/** Last representable instant of `date`'s day, in local time. */
export const endOfDay = (date: Date): Date => {
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return end;
};
